const states = require('us-state-converter');
import { Loader } from 'google-maps';

let allMarkers = [];

export default (preState = null, preCareerType = null, preSpecialty = null, apiKey = null, preCareerCategory = null, preHospitalSystem = null, preVisa = null) => ({
  name: 'CareersSearch',
  // * data()
  start: false,
  selectedCareerCategory: '',
  selectedCareerType: '',
  selectedSpecialty: '',
  selectedState: '',
  selectedVisa: false,
  selectedCapExempt: false,
  filterType: '',
  hospitalSystem: '',
  careers: [],
  filteredCareers: [],
  filteredCareersWithoutState: [],
  currentChange: null,
  careersCategories: [],
  careersTypes: [],
  careersTypesLeadership: [],
  careersTypesClinical: [],
  specialties: [],
  expanded: true,
  desktop: window.innerWidth >= 992 ? true : false,
  states: [],
  baseEndpoint: `${window.location.origin}/api/v2/`,
  constants: {
    VERSION: 'quarterly',
    API_KEY: apiKey,
  },
  markers: [],
  map: null,
  google: null,
  async init() {
    const res = await fetch(`${this.baseEndpoint}careers`);
    this.careers = await res.json();
    this.filteredCareers = this.careers;
    this.filteredCareersWithoutState = this.careers;
    this.specialties = await this.makeSelectFieldEndpoint('specialtydropdown');
    this.careersTypes = this.makeSelectFieldCareerType('careerType', 'careerTypeID');
    this.careersCategories = this.makeSelectField('careerCategory', 'careerCategoryID');
    this.states = this.makeStatesSelectField();

    const urlParams = new URLSearchParams(window.location.search);
    const paramCareerType = urlParams.get('career');
    const paramSpecialty = urlParams.get('specialty');
    const paramState = urlParams.get('state');
    const paramCareerCategory = urlParams.get('career_type');
    const paramHospitalSystem = urlParams.get('hospital_system');
    const paramVisa = urlParams.get('j1visa');
    const paramCapExempt = urlParams.get('cap_exempt');

    // A promise that loops through careers, and retrieves their filtered system locations (if applicable).
    let pr = () => {
      return new Promise(async (resolve, reject) => {
        let i = 0;
        for (const [key, item] of Object.entries(this.careers)) {
          if (item.hospitalSystem !== '') {
            let systemLocations = item.hospitalSystemLocations.split(", ");
            let systemExclusions = item.locationsToExclude.split(", ");
            let filteredLocationIDs = systemLocations.filter(x => !systemExclusions.includes(x));
            let filter = filteredLocationIDs.join('+');

            const endpoint = await fetch(`${window.location.origin}/api/v1/systemlocations/${filter}`);
            const locations = await endpoint.json();
    
            this.careers[key].filteredSystemLocations = locations;
          }
          if (i === this.careers.length - 1) resolve();
          i++;
        }
      });
    }

    if (preState || paramState) {
      this.selectedState = paramState ? paramState : preState;
    }
    if (preCareerType || paramCareerType) {
      let temp = '';
      let careerTypeId = '';
      let filterType = 'A';
      
      if (paramCareerType.length !== 0) {
        temp = paramCareerType.split('-');
      } else if (preCareerType.length !== 0) {
        temp = preCareerType.split('-');
      }

      careerTypeId = parseInt(temp[0]);
      filterType = (temp[1] && temp[1] !== null) ? temp[1] : 'A';

      let careerType = (paramCareerType == 'leadership') ? paramCareerType : careerTypeId + "-" + filterType;

      this.selectedCareerType = careerType;
    }
    if (preCareerCategory || paramCareerCategory) {
      this.selectedCareerCategory = paramCareerCategory ? paramCareerCategory : preCareerCategory;
    }
    if (preHospitalSystem || paramHospitalSystem) {
      this.hospitalSystem = paramHospitalSystem ? paramHospitalSystem : preHospitalSystem;
    }
    if (preSpecialty || paramSpecialty) {
      this.selectedSpecialty = paramSpecialty ? paramSpecialty : preSpecialty;
    }
    if (preVisa || paramVisa) {
      let visaVal = (paramVisa == 1 || preVisa == 1) ? true : false;
      this.selectedVisa = visaVal;
    }
    if (paramCapExempt) {
      let capExemptVal = (paramCapExempt == 1) ? true : false;
      this.selectedCapExempt = capExemptVal;
    }

    // 1/23/23: They want the map to appear even if the filters are empty.
    // 5/12/23: This can only run if the above promise is fulfilled.
    pr().then(() => {
      if (this.constants.API_KEY) {
        this.filterCareers();
      }
    });
  },
  makeSelectField(name, id) {
    // Keep the filter dropdown fully populated.
    // 12/20/22 - They asked that it go back to being progressive.
    const filteredCareers = this.filteredCareers.filter((career) => career[name]);
    //const filteredCareers = this.careers.filter((career) => career[name]);
    const reducedCareers = filteredCareers.reduce((acc, career) => {
      if (!acc.find((item) => item[id] === career[id])) {
        acc.push({
          id: career[id],
          name: career[name],
        });
      }
      return acc;
    }, []);
    const uniqueCareers = reducedCareers.filter((career, index, self) => index === self.findIndex((t) => t.id === career.id));
    const sortedItems = uniqueCareers.sort((a, b) => (a[name] > b[name] ? 1 : -1));
    return sortedItems;
  },

  makeSelectFieldCareerType(name, id) { // 'careerType', 'careerTypeId'
    // They asked for this to no longer fully-populate. 12/16/22
    const filteredCareers = this.filteredCareers.filter((career) => career[name]);
    //const filteredCareers = this.careers.filter((career) => career[name]);
    const reducedCareers = filteredCareers.reduce((acc, career) => {
    //const reducedCareers = usableCareers.reduce((acc, career) => {
      var careerFilter = (career.searchTitle && career.searchTitle.length !== 0) ? career.searchTitle : career[name];
      if (!acc.find((item) => item[id] === career[id])) {
      //if (!acc.find((item) => item[name] === careerFilter)) {
        let filterType = (career.searchTitle && career.searchTitle.length !== 0) ? 'title' : 'type';
        let tid = (career.searchTitle.length === 0) ? career[id] : career.searchTitleId;
        let typeabbr = (career.searchTitle.length === 0) ? 'A' : 'B'; // Type = A; Title = B
        acc.push({
          //id: (career.searchTitle.length === 0) ? career[id] : career.searchTitleId,
          id: tid + "-" + typeabbr,
          //name: career[name],
          name: careerFilter,
          role: career.careerTypeRole,
          sortPriority: career.field_sort_priority,
          searchTitle: career.searchTitle,
          filterType: filterType,
          searchTitleId: (career.searchTitle.length === 0) ? 0 : career.searchTitleId
        });
      }
      return acc;
    }, []);

    const uniqueCareers = reducedCareers.filter((career, index, self) => {
      // Old version:
      return (index === self.findIndex((t) => t.id === career.id));

      // New version:
      //return (index === self.findIndex((t) => (t.id === career.id && t.filterType === 'type' && career.filterType === 'type') || (t.filterType === 'title' && career.filterType === 'title' && t.searchTitleId === career.searchTitleId)));
  });

    // Sort items according to priority, then name.
    const sortedItems = uniqueCareers.sort(function(a, b) {
      if (!a.sortPriority) {
        a.sortPriority = 0;
      }
      return b.sortPriority - a.sortPriority || a.name.localeCompare(b.name);
    });
    if (name === 'careerCategory') {
      sortedItems.reverse();
    }

    this.careersTypesClinical = sortedItems.filter((item) => item.role === 'clinical');
    this.careersTypesLeadership = sortedItems.filter((item) => item.role === 'leadership');

    return [
      {
        name: 'Clinical',
        types: JSON.parse(JSON.stringify(this.careersTypesClinical)),
      },
      {
        name: 'Leadership',
        types: JSON.parse(JSON.stringify(this.careersTypesLeadership)),
      },
    ];
  },

  async makeSelectFieldEndpoint(filterBy) {
    const res = await fetch(`${window.location.origin}/api/v1/tax/${filterBy}`);
    const taxList = await res.json();

    const taxListNames = taxList.map((item) => {
      return {
        id: item.tid,
        name: item.name,
      };
    });

    // remove TaxListNames that are not in the filteredCareers
    const filteredTaxListNames = taxListNames.filter((tax) => {
      //return this.filteredCareers.find((career) => {
      // Actually, keep the taxlistnames that are not in the filteredcareers
      return this.careers.find((career) => {
        return career.specialtyID === tax.id || career.careerTagId.includes(tax.id);
      });
    });

    return filteredTaxListNames;
  },
  makeStatesSelectField() {
    // Swap out filtered careers with all careers. This is to ensure the dropdowns are fully populated.
    //const regionStates = this.filteredCareers.map((career) => career.regionStates.split(', '));
    const regionStates = this.careers.map((career) => career.regionStates.split(', '));
    //const states = this.filteredCareers.map((career) => career.state);
    const states = this.careers.map((career) => career.state);
    const combinedStates = states.concat(regionStates.flat()).filter((item) => item !== '');
    const uniqueStates = [...new Set(combinedStates)];
    const statesWithAbbr = uniqueStates.map((state) => {
      return {
        name: this.stateCodeToName(state),
        code: state,
        invalid: (this.filteredCareers.some(e => e.state == state)) ? true : false
      };
    });

    statesWithAbbr.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return statesWithAbbr;
  },
  stateCodeToName(code) {
    if (code === '' || code === 'any') {
      return 'all States';
    }
    return states.fullName(code);
  },
  getSelectedSpecialty() {
    return this.selectedSpecialty;
  },
  convertToSlug(text) {
    return text
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  },
  setUrlParams(careerCategory = null, careerType = null, specialty = null, state = null) {
    const url = new URL(window.location.href);
    if (careerCategory) {
      url.searchParams.set('career_type', careerCategory);
    } else {
      url.searchParams.delete('career_type');
    }
    if (careerType) {
      url.searchParams.set('career', careerType);
    } else {
      url.searchParams.delete('career');
    }
    if (specialty) {
      url.searchParams.set('specialty', specialty);
    } else {
      url.searchParams.delete('specialty');
    }
    if (state) {
      url.searchParams.set('state', state);
    } else {
      url.searchParams.delete('state');
    }
    window.history.pushState({ path: url.href }, '', url.href);
  },
  async filterCareers(changing = null) {
    this.currentChange = changing;

    let careerType = this.selectedCareerType === 'any' || '' ? '' : this.selectedCareerType;
    let careerCategory = this.selectedCareerCategory === 'any' || '' ? '' : this.selectedCareerCategory;
    let specialty = this.selectedSpecialty === 'any' || '' ? '' : this.selectedSpecialty;
    let state = this.selectedState === 'any' || '' ? '' : this.selectedState;
    let hospitalSystem = this.hospitalSystem === 'any' || '' ? '' : this.hospitalSystem;
    let careerTypeId = '';
    let filterTypeTemp = null;
    let visa = this.selectedVisa;
    let capExempt = this.selectedCapExempt;

    if (careerType.length !== 0) {
      let temp = careerType.split('-');
      careerTypeId = parseInt(temp[0]);
      filterTypeTemp = (temp[1] == 'B') ? 'title' : 'type';
    }

    let filterDropdown = document.querySelector('#career-type');
    let filterType = (filterTypeTemp !== null) ? filterTypeTemp : filterDropdown.options[filterDropdown.selectedIndex].getAttribute('filterType');

    const filteredCareers = this.filterOutCareers(this.careers, filterType, careerTypeId, careerCategory, specialty, state, false, hospitalSystem, visa, capExempt);
    const filteredCareersWithoutState = this.filterOutCareers(this.careers, filterType, careerTypeId, careerCategory, specialty, state, true, hospitalSystem, visa, capExempt);

    this.filteredCareers = filteredCareers;
    this.filteredCareersWithoutState = filteredCareersWithoutState;

    // New Map filter
    if (this.filteredCareersWithoutState.length > 0) {
      this.addResultsToMap(this.filteredCareersWithoutState);
    }

    this.specialties = await this.makeSelectFieldEndpoint('specialtydropdown');
    this.careersTypes = this.makeSelectFieldCareerType('careerType', 'careerTypeID');
    this.careersCategories = this.makeSelectField('careerCategory', 'careerCategoryID');
    this.states = this.makeStatesSelectField();

    this.setUrlParams(careerCategory, careerType, specialty, state);

    // moved this from above this.specialties = ~, to here.
    if (!this.start && this.constants.API_KEY) {
      const loader = new Loader(this.constants.API_KEY, {'version': this.constants.VERSION, 'libraries': ['marker']});
      this.google = await loader.load();
      this.start = true;
      this.initMap();
    }
  },
  filterOutCareers(careers, filterType, careerTypeId, careerCategory, specialty, state, ignoreStates = true, hospitalSystem, visa, capExempt) {
    const filteredCareers = careers.filter((career) => {
      career = JSON.parse(JSON.stringify(career)); // Adding this to make career a real object, instead of a proxy object.
      
      // Filter by career type ("Career" dropdown) 
      // First check if a leadership career. Else, filter normally.
      if (this.selectedCareerType == 'leadership') {
        if (career.careerTypeRole != 'leadership') {
          return false;
        }
      } else {
        // Convert IDs to ints so they can appropriately match with careerTypeId
        if (filterType =="type" || filterType == null) {
          if (careerTypeId !== '' && parseInt(this.selectedCareerType) !== parseInt(career.careerTypeID)) {
            return false;
          }
        } else if (filterType == "title") {
          if (careerTypeId !== parseInt(career.searchTitleId)) {
            return false;
          }
        } else {
          return false;
        }
      }

      // Filter by career category.
      if (careerCategory !== '' && this.selectedCareerCategory !== career.careerCategoryID) {
        return false;
      }

      // Filter by specialty.
      if (specialty !== '' && this.selectedSpecialty !== career.specialtyID) {
        // Filter by career tags, which also appear under the Specialty Field dropdown.
        if (!career.careerTagId.includes(specialty)) {
          return false;
        }
      }

      // Filter by state / location -- but only if specified!
      if (ignoreStates == false) {
        if (state !== '' && this.selectedState !== career.state) {
          // If the career is part of a hospital system, filter location accordingly.
          if (career.locationType == 'Hospital System') {
            if (career.filteredSystemLocations !== null) {
              let systemLocation = false;

              career.filteredSystemLocations.forEach((item) => {
                if (item.state == this.selectedState) {
                  systemLocation = true;
                }
              });

              if (systemLocation == false) {
                return false;
              }
            }
          }
          // If a location is set to Nationwide or Traveling, or the region states include the selected state, the career should appear.
          else if (career.locationType !== 'Nationwide' && career.locationType !== 'Traveling' && !(career.locationType == 'Regional' && career.regionStates.indexOf(this.selectedState) > -1)) {
            return false;
          }
        }

        // If a career's location is not published, the career should not appear in the list -- but only if the location type is Location.
        if (career.locationStatus !== "1" && career.locationType === "Location") {
          return false;
        }
      }

      // Filter out careers that aren't part of the selected hospital system.
      if (hospitalSystem.length >= 1) {
        if (career.hospitalSystem != hospitalSystem && career.locationHospitalSystem != hospitalSystem && career.locationHospitalSystem.indexOf(hospitalSystem) == -1) {
          return false;
        }
      }

      // Filter careers by whether or not they accept a J1 Visa.
      if (visa === true) {
        let visaString = visa.toString();
        let boolString = (visaString.charAt(0).toUpperCase() + visaString.slice(1));
        if (career.visaLocation != boolString) {
          return false;
        }
      }

      // Filter careers by whether or not they're cap exempt.
      if (capExempt == true) {
        let capExemptString = capExempt.toString();
        let boolString = (capExemptString.charAt(0).toUpperCase() + capExemptString.slice(1));
        if (career.capExempt != boolString) {
          return false;
        }
      }

      // Assuming all other checks passed, return true.
      return true;
    });

    return filteredCareers;
  },
  async clearFilters() {
    this.selectedCareerType = '';
    this.selectedCareerCategory = '';
    this.selectedSpecialty = '';
    this.selectedState = '';
    this.selectedVisa = 0;
    this.selectedCapExempt = 0;
    this.filteredCareers = this.careers;
    this.filteredCareersWithoutState = this.careers;
    this.specialties = await this.makeSelectFieldEndpoint('specialtydropdown');
    this.careersTypes = this.makeSelectFieldCareerType('careerType', 'careerTypeID');
    this.careersCategories = this.makeSelectField('careerCategory', 'careerCategoryID');
    this.states = this.makeStatesSelectField();
    this.currentChange = null;

    this.addResultsToMap(this.filteredCareersWithoutState);

    //remove url params
    const url = new URL(window.location.href);
    url.searchParams.delete('career_type');
    url.searchParams.delete('career');
    url.searchParams.delete('specialty');
    url.searchParams.delete('state');
    window.history.pushState({ path: url.href }, '', url.href);
  },

  async initMap() {
    //if (!this.google) return;

    let zoom = (!this.desktop) ? 2 : 3.4;
    let minZoom = (!this.desktop) ? 2 : 3.5;
    let maxZoom = 14;

    this.map = new this.google.maps.Map(this.$refs.map, {
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      zoom: zoom, // previously 3.4
      minZoom: minZoom, // previously 3.5
      maxZoom: maxZoom, // previously 14
      center: { lat: 34.0902, lng: -85.7129 },
      componentRestrictions: { country: 'us' },
      mapId: "b6dba40959965a47"
    });
    if (this.filteredCareersWithoutState.length > 0) {
      this.addResultsToMap(this.filteredCareersWithoutState);
    }
  },
  addResultsToMap(dataArray) {
    // Clear the map first.
    this.deleteMarkers();

    // If google doesn't init, return
    if (!this.google) return;
    this.bounds = new this.google.maps.LatLngBounds();

    dataArray.forEach((item) => {
      if (!item.lat || !item.lng) return;
      let infoWindow = null;
      // previously item.url, now item.locationUrl
      infoWindow = new this.google.maps.InfoWindow({
        content: `
          <div class="pr-4 text-left max-w-[210px]">
            <a href="${item.locationUrl}" class="no-underline hover:underline">
              <h4 class="font-bold text-[14px] leading-[18px] text-secondary-500 mb-3">
                ${item.location ? item.location : ''}
              </h4>
              <p class="text-[12px] leading-[16px] text-gray-600">${item.fullAddress ? item.fullAddress : ''}</p>
            </a>
          </div>
        `,
      });

      const glyphImg = document.createElement("img");
      glyphImg.src = `${window.location.origin}/themes/fire/theme/assets/media/images/icon--map-pin.png`

      const marker = new this.google.maps.marker.AdvancedMarkerElement({
        map: Alpine.raw(this.map),
        position: {lat: parseFloat(item.lat), lng:parseFloat(item.lng)},
        content: glyphImg,
        collisionBehavior: 'REQUIRED',
        gmpClickable: true,
      });
      marker.addListener('click', () => {
        if (this.prevOpenInfoWindow) {
          this.prevOpenInfoWindow.close();
        }
        this.prevOpenInfoWindow = infoWindow;
        infoWindow.open(Alpine.raw(this.map), marker);
      });

      if (this.selectedState.length == 0 || this.selectedState === 'any') {
        this.bounds.extend({lat: parseFloat(item.lat), lng:parseFloat(item.lng)});
      }

      allMarkers.push(marker);
    }); // end forEach

    if (this.selectedState.length > 0 || this.currentChange == 'state') {
      this.filteredCareers.forEach((item) => {
        if (!item.lat || !item.lng || item.lat.length == 0 || item.lng.length == 0) return;
        if (item.state !== null && item.state != this.selectedState) return;
        const stateLatLng = new this.google.maps.LatLng(item.lat, item.lng);
        this.bounds.extend(stateLatLng);
      });
    }

    this.addMarkersToMap();
  },
  addMarkersToMap() {
    this.setMapOnAll(Alpine.raw(this.map));
    this.fitToBounds();
  },
  setMapOnAll(map) {
    for (let i = 0; i < allMarkers.length; i++) {
      allMarkers[i].map = map;
    }
  },
  clearMarkers() {
    this.setMapOnAll(null);
  },
  deleteMarkers() {
    this.clearMarkers();
    allMarkers = [];
  },
  panToCoords(coords) {
    if (!this.google) return;
    const latLng = new this.google.maps.LatLng(coords.lat, coords.lng);
    this.map.panTo(latLng);
  },
  fitToBounds() {
    this.map.fitBounds(this.bounds);
    this.map.panToBounds(this.bounds);
  },
});
